import type { SYSTableDef } from "../../../../_ovlclient/src/library/table/tableapi"

export let tblEPT: SYSTableDef = {
  id: "SYSEPT",

  feature: undefined,
  database: {
    dataIdField: "Id",
  },
  server: {
    endpoint: "endpointtestingmanagement",
  },
  options: {
    initial_paging: { page: 0, pageSize: 200 },
  },

  features: {
    page: true,
    showFooterButtons: true,
    filter: true,
    edit: true,
  },
  columns: {
    Id: {
      type: "int",
      sortable: true,
      ui: { visibility: "Table" },
    },
    Url: { ui: { alwaysReadOnly: true }, schema: { isCalculatedColumn: true } },
    CapturedRequest: {
      ui: { expandTableCellOnClick: true, visibility: "Table" },
    },
    JmesPathExpression: {
      ui: { visibility: "Edit" },
    },
    JmesPathResult: {
      ui: { visibility: "Edit", alwaysReadOnly: true },
      schema: { isCalculatedColumn: true },
    },
    ResponseBody: {
      control: "textarea",
      ui: { visibility: "Edit" },
      schema: { isCalculatedColumn: true },
    },
  },
}
